import React from "react";
import PropTypes from "prop-types";

const RegistrationSidebar = (props) => {
    const fullMenu = props.staticMenu.concat(props.enableMenuList);
    // const enableMenuList = Object.entries(props.dynamicMenuEnable).filter(([, v]) => (v === true || v === "true")).map(([k]) => k);    
    return (<div className={"col-md-3"}>
            <ul className="list-group" id="vendorRegMenus">
            {fullMenu.map((menu, i) => (
                <li key={`sidebar_${i}`}
                    onClick={() => {
                        if(menu.clickEvent){
                            props.onMenuClick(menu.id);
                        }
                    }}
                >
                    <span
                        className={props.activeTab === menu.id ? `active ${menu.className}` : menu.className}
                        id={menu.id}
                    >
                        {menu.label}
                    </span>
                </li>
            ))}
        </ul>
    </div>);
};

RegistrationSidebar.propTypes = {
    activeTab: PropTypes.string,
    onMenuClick: PropTypes.func.isRequired,
    staticMenu: PropTypes.array.isRequired,
    enableMenuList:PropTypes.array
};

export default RegistrationSidebar;